module.exports = __webpack_public_path__ + "img/logo-Eisai_03.b2769727.png";